import { render, staticRenderFns } from "./MarcaProductoList.vue?vue&type=template&id=537b3dc7&scoped=true&"
import script from "./MarcaProductoList.vue?vue&type=script&lang=js&"
export * from "./MarcaProductoList.vue?vue&type=script&lang=js&"
import style0 from "./MarcaProductoList.vue?vue&type=style&index=0&id=537b3dc7&lang=scss&scoped=true&"
import style1 from "./MarcaProductoList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./MarcaProductoList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b3dc7",
  null
  
)

export default component.exports